import { connect } from 'react-redux';
import { eventActions, userActions, alertActions, guestActions } from '../../actions';
import Dashboard from '../../components/host/Dashboard';

const mapDispatchToProps = (dispatch) => {
  return {
    getEvent: () => {
      return dispatch(eventActions.loadEvent());
    },
    loadGuests: () => {
      return dispatch(guestActions.loadGuests());
    },
    updateUser: (user) => {
      return dispatch(userActions.updateUser(user));
    },
    updateEvent: (e) => {
      return dispatch(eventActions.updateEvent(e));
    },
    clearAlert: () => {
      dispatch(alertActions.clear());
    },
    errorAlert: (message) => {
      dispatch(alertActions.error(message));
    },
    addGuest: (guest, callback) => {
      dispatch(guestActions.addGuest(guest, callback));
    },
    updateGuest: (guest) => {
      dispatch(guestActions.updateGuest(guest));
    },
  }
}

function mapStateToProps(state, ownProps) {
  const { message, type } = state.alerts;
  return {
    alertMessage: message,
    alertType: type,
    userGuests: state.userGuests.guests,
    isLoading: state.events.isLoading,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
